import { compose, ifElse, is, isEmpty, isNotNil, not } from "ramda";

const hasData = ifElse(is(Object), compose(not, isEmpty), isNotNil);

export default hasData;
